import { useEffect, useState } from 'react';

// Toast global do design system — store leve sem dependência externa.
// Erros de mutação são disparados automaticamente pelo MutationCache
// (lib/query.ts); sucesso é disparado explicitamente nos fluxos importantes.

export type ToastItem = { id: number; kind: 'success' | 'error'; message: string };

type Listener = (toasts: ToastItem[]) => void;

let items: ToastItem[] = [];
let nextId = 1;
const listeners = new Set<Listener>();

function emit() {
  for (const l of listeners) l(items);
}

function dismiss(id: number) {
  items = items.filter((t) => t.id !== id);
  emit();
}

function push(kind: ToastItem['kind'], message: string, ttlMs: number) {
  // Não empilha o mesmo texto repetido (ex.: retry de mutação).
  if (items.some((t) => t.kind === kind && t.message === message)) return;
  const id = nextId++;
  items = [...items, { id, kind, message }];
  emit();
  setTimeout(() => dismiss(id), ttlMs);
}

export const toast = {
  success: (message: string) => push('success', message, 3500),
  error: (message: string) => push('error', message, 6000),
};

export function ToastContainer() {
  const [list, setList] = useState<ToastItem[]>(items);
  useEffect(() => {
    listeners.add(setList);
    return () => {
      listeners.delete(setList);
    };
  }, []);
  if (list.length === 0) return null;
  return (
    <div className="toast-container" role="status" aria-live="polite">
      {list.map((t) => (
        <button
          key={t.id}
          type="button"
          className={`toast ${t.kind === 'error' ? 'toast-error' : 'toast-success'}`}
          onClick={() => dismiss(t.id)}
        >
          <span className="toast-icon">{t.kind === 'error' ? '✕' : '✓'}</span>
          <span>{t.message}</span>
        </button>
      ))}
    </div>
  );
}
